module.exports = __webpack_public_path__ + "static/ss-0eecf8b2783598f1db724a280dfdc941.png";